module.exports = __webpack_public_path__ + "img/ecocert.0d61b199.svg";